import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const HomeIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 19 19", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g
                    stroke="#210071"
                    strokeWidth="1.2"
                    transform="translate(-25 -145)"
                >
                    <g transform="translate(25.5 146)">
                        <path d="M2 7L2 16.5 7 16.5 7 9.5 11 9.5 11 16.5 16 16.5 16 7"></path>
                        <path d="M0 9L9 0 18 9"></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
